import React from "react";

const Hdg2 = ({ section = "" }) => {
	return (
		<h1 style={{ marginBottom: "20px" }}>
			Benefit For Children {section ? section : ""}
		</h1>
	);
};

export default Hdg2;
